// extracted by mini-css-extract-plugin
export var avatarContainer = "_3p-1";
export var largeAvatarContainer = "_3p-2";
export var smallAvatarContainer = "_3p-0";